import "./style.less";

import loginModalController from "./modal-controller";
import loginModalFactory from "./factory";

const modul = angular
    .module("loginModalModule", [])

    .factory("loginModalFactory", loginModalFactory)
    .controller("loginModalController", loginModalController);

export default modul.name;
